module.exports = __webpack_public_path__ + "assets/img/u5e7070aa0a973.29347277.png";